import React from "react";
import { GeneralSearchInput } from "components/GeneralSearchInput";

import "./style.scss";


export const GeneralSearch = (props) => {
    return (
        <> <GeneralSearchInput props={props}/></>
    )
}